import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { IBusy } from './base'
import { ModalSize } from './modal-size'
import { ModalBackDrop } from './modal-back-drop'
import { NotifyIcon } from './notify-icon'
import { ConfirmComponent } from './confirm.component'
import { NotifyComponent } from './notify.component'
import { MultilineComponent } from './multiline.component'
import { BusyComponent } from './busy.component'
import { PromptValueComponent } from './prompt-value.component'
import { PromptBoolComponent } from './prompt-bool.component'
import { LeaveMeetingPromptComponent } from './leave-meeting-prompt.component'

export class ModalService {
    constructor(private modal: NgbModal) {}

    private modalsOpen: NgbModalRef[] = []
    private trackModal(ref: NgbModalRef) {
        this.modalsOpen.push(ref)

        ref.result.then(
            saveResult => {
                this.modalsOpen.pop()
            },
            errorResult => {
                this.modalsOpen.pop()
            },
        )

        return ref
    }
    public dismissAll() {
        while (this.modalsOpen.length > 0) {
            var ref = this.modalsOpen.pop()
            if (ref) {
                ref.dismiss()
            }
        }
    }

    public open(
        component: any,
        size: ModalSize = ModalSize.default,
        backdrop: ModalBackDrop = ModalBackDrop.darkAndActive,
        beforeDismiss = () => {
            return true
        },
    ): NgbModalRef {
        var ref = this.modal.open(component, { size: <any>size, backdrop: backdrop as any, beforeDismiss })
        return this.trackModal(ref)
    }
    public confirm(title: string, message: string, size: ModalSize = ModalSize.small): Promise<any> {
        var ref = this.modal.open(ConfirmComponent, { size: <any>size })
        var confirm: ConfirmComponent = ref.componentInstance
        confirm.title = title
        confirm.message = message

        this.trackModal(ref)

        return ref.result
    }
    public information(title: string, message: string, size: ModalSize = ModalSize.small): Promise<any> {
        return this.notify(title, message, NotifyIcon.information, size)
    }
    public warning(title: string, message: string, size: ModalSize = ModalSize.small): Promise<any> {
        return this.notify(title, message, NotifyIcon.warning, size)
    }
    public error(title: string, message: string, size: ModalSize = ModalSize.small): Promise<any> {
        return this.notify(title, message, NotifyIcon.error, size)
    }
    private notify(title: string, message: string, icon: NotifyIcon, size: ModalSize = ModalSize.small): Promise<any> {
        var ref = this.modal.open(NotifyComponent, { size: <any>size, backdrop: <any>ModalBackDrop.darkAndInactive })
        var notify: NotifyComponent = ref.componentInstance
        notify.title = title
        notify.message = message
        notify.icon = icon

        this.trackModal(ref)

        return ref.result
    }
    public multiline(
        title: string,
        messages: string[],
        size: ModalSize = ModalSize.large,
        rows: number = 10,
        showIcon: boolean = true,
    ): Promise<any> {
        var ref = this.modal.open(MultilineComponent, { size: <any>size, backdrop: <any>ModalBackDrop.darkAndInactive })
        var multiline: MultilineComponent = ref.componentInstance
        multiline.title = title
        multiline.setMessages(messages)
        multiline.rows = rows
        multiline.showIcon = showIcon

        return ref.result
    }
    public busy(message: string): IBusy {
        var ref = this.modal.open(BusyComponent, {
            size: <any>ModalSize.small,
            backdrop: <any>ModalBackDrop.darkAndInactive,
            keyboard: true,
        })
        var notify: BusyComponent = ref.componentInstance
        notify.message = message

        this.trackModal(ref)

        return notify
    }
    public promptValue(
        title: string,
        message: string,
        inputLabel: string,
        inputValueType: string,
        size: ModalSize = ModalSize.medium,
    ): Promise<any> {
        var ref = this.modal.open(PromptValueComponent, { size: <any>size, backdrop: <any>ModalBackDrop.darkAndInactive })
        var prompt: PromptValueComponent = ref.componentInstance
        prompt.title = title
        prompt.message = message
        prompt.inputLabel = inputLabel
        prompt.inputValueType = inputValueType
        this.trackModal(ref)
        return ref.result
    }
    public promptBool(
        title: string,
        message: string,
        input1Label: string,
        input2Label = '',
        size: ModalSize = ModalSize.medium,
    ): Promise<any> {
        var ref = this.modal.open(PromptBoolComponent, { size: <any>size, backdrop: <any>ModalBackDrop.darkAndInactive })
        var prompt: PromptBoolComponent = ref.componentInstance
        prompt.title = title
        prompt.message = message
        prompt.input1Label = input1Label
        prompt.input2Label = input2Label
        this.trackModal(ref)
        return ref.result
    }

    public leaveMeetingPrompt(targetUrl: string, isLead: boolean, size: ModalSize = ModalSize.small): Promise<'leave' | 'newTab'> {
        var ref = this.modal.open(LeaveMeetingPromptComponent, { size: <any>size })
        var prompt: LeaveMeetingPromptComponent = ref.componentInstance
        prompt.targetUrl = targetUrl
        prompt.isLead = isLead
        this.trackModal(ref)
        return ref.result
    }
}
